import { configureStore } from '@reduxjs/toolkit';
import errorConfig from './slices/errorConfig';


const store = configureStore({
  reducer: {
    errorConfig: errorConfig,
  },
});

export default store;